import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=0787a9fc&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=0787a9fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787a9fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0787a9fc')) {
      api.createRecord('0787a9fc', component.options)
    } else {
      api.reload('0787a9fc', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=0787a9fc&scoped=true", function () {
      api.rerender('0787a9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/no-need-authorities/notifications.vue"
export default component.exports